export default __webpack_public_path__ + "static/051-945d905aa2ae3bd96efdc1241fcc72a9.jpg";